import { render, staticRenderFns } from "./announce.vue?vue&type=template&id=06faf3c3&scoped=true&"
import script from "./announce.vue?vue&type=script&lang=js&"
export * from "./announce.vue?vue&type=script&lang=js&"
import style0 from "./announce.vue?vue&type=style&index=0&id=06faf3c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faf3c3",
  null
  
)

export default component.exports